import { HStack } from '@/components/sgBootstrapReactWrapper';
import type { FilterModel } from 'ag-grid-enterprise';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterBadge } from './FilterBadge.tsx';

type Props = {
  identifier: string;
  filters: FilterModel;
  onClearRequested: (columnId: string) => void;
  onClearAllRequested: () => void;
};

export const ActiveAGGridFiltersDisplay = ({
  identifier,
  filters,
  onClearRequested,
  onClearAllRequested,
}: Props) => {
  const badges = useMemo(
    () =>
      Object.entries(filters).map(([columnId, filterModel]) => (
        <FilterBadge
          key={columnId}
          identifier={identifier}
          columnId={columnId}
          filterModel={filterModel}
          onClearRequested={onClearRequested}
        />
      )),
    [filters, identifier, onClearRequested],
  );

  return (
    <HStack gap="8px" horizontalAlignment="start" className="user-select-none">
      <div className="fw-bold">
        <FormattedMessage id="activeFilters" />
      </div>

      {badges.length > 0 ? (
        <HStack gap="8px">
          {badges}

          {badges.length > 1 && (
            <button
              type="button"
              className="btn btn-link btn-md"
              onClick={onClearAllRequested}
              data-e2e={`${identifier}.remove-all-filters`}
            >
              <FormattedMessage id="removeAll" />
            </button>
          )}
        </HStack>
      ) : (
        <span data-e2e={`${identifier}.no-filters`}>
          <FormattedMessage id="noActiveFilters" />
        </span>
      )}
    </HStack>
  );
};
